export default __webpack_public_path__ + "static/media/icon-calendar.1bd87109.svg";